import type { FilterTypes } from '../../constants/enums'
import type { RootState } from '../store'

export const filterSelector = (state: RootState, type: FilterTypes) =>
  state.filters[type]

export const resetFiltersSelector = (state: RootState) => state.filters.reset
